// @ts-nocheck
 

// // @ts-nocheck
// import { useFormik } from 'formik';
// import React, { useState } from 'react';
// import { Form, InputGroup, Button } from 'react-bootstrap';
// import * as Yup from 'yup';
// import { useDispatch } from 'react-redux';
// import { useNavigate } from 'react-router-dom';
// import { useTranslation } from 'react-i18next';
// import { jwtDecode } from 'jwt-decode';
// import CustomAlert from '@components/Shared/Alert/CustomAlert';
// import { ChangePass } from '@store/Login/loginSlice';
// import PasswordChecklist from 'react-password-checklist';
// import { useSelector } from 'react-redux';

// function ChangePassword({ onClose }) {
//   const { t } = useTranslation();
//   const Token = useSelector(s => s.userLogin?.AuthUser?.token);
//   const user = jwtDecode(Token);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   //#region ShowPassword
//   const [showPassword, setShowPassword] = useState(false);
//   const togglePasswordVisibility = () => {
//     setShowPassword(prevShowPassword => !prevShowPassword);
//   };

//   const [shownewPassword, setNewshowPassword] = useState(false);
//   const toggleNewPasswordVisibility = () => {
//     setNewshowPassword(prevShowPassword => !prevShowPassword);
//   };

//   const [showconfirmnewPassword, setConfirmnewshowPassword] = useState(false);
//   const toggleConfirmNewPasswordVisibility = () => {
//     setConfirmnewshowPassword(prevShowPassword => !prevShowPassword);
//   };
//   //#endregion

//   //#region formik
//   const formik = useFormik({
//     initialValues: {
//       usersName: user?.UserName,
//       currentPassword: '',
//       newPassword: '',
//       comfirmdNewPassword: ''
//     },

//     validationSchema: Yup.object({
//       usersName: Yup.string().trim().required('Username is required'),
//       currentPassword: Yup.string().trim().required('Password is required'),

//       newPassword: Yup.string()
//         .min(8, 'كلمة المرور يجب أن تحتوي على أكثر من 8 أحرف')
//         .matches(/(?=.*[A-Z])/, 'يجب أن تحتوي كلمة المرور على حرف كبير واحد على الأقل')
//         .matches(/(?=.*\d)/, 'يجب أن تحتوي كلمة المرور على رقم واحد على الأقل')
//         .matches(/(?=.*[!@#$%^&*])/, 'يجب أن تحتوي كلمة المرور على أحرف خاصة')
//         .required(),

//       comfirmdNewPassword: Yup.string()
//         .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
//         .required('Please confirm your new password')
//     }),

//     onSubmit: (values, { setErrors }) => {
//       dispatch(
//         ChangePass({
//           usersName: values.usersName,
//           currentPassword: values.currentPassword,
//           newPassword: values.newPassword,
//           comfirmdNewPassword: values.comfirmdNewPassword
//         })
//       )
//         .unwrap()
//         .then(res => {
//           // console.log(res);
//           if (res?.succeeded === true) {
//             CustomAlert({ action: 'Add', msg: 'تم تغيير كلمة المرور بنجاح' });
//             formik.resetForm();
//             formik.setSubmitting(false);
//             navigate(-1, { replace: true });
//           } else {
//             CustomAlert({ action: 'Error', msg: res?.message });
//             formik.setSubmitting(false);
//           }
//         })
//         .catch(error => {
//           console.log(error);
//           formik.setSubmitting(false);
//         });
//     }
//   });
//   //#endregion

//   return (
//     <>
//       <div className=' p-4'>
//         <Form onSubmit={formik.handleSubmit}>
//           <div className=' bg-inverse bg-opacity-10 rounded-1 p-2 mb-3 border border-theme '>
//             <h5 className='text-center p-0 m-0'>{t('ChangePassword')}</h5>
//           </div>

//           <div className='mb-3'>
//             <label className='form-label fw-semibold'>
//               <i className='bi bi-person-fill text-theme me-2' aria-hidden='true' />
//               {t('UserName')} <span className='text-danger'>*</span>
//             </label>

//             <Form.Control
//               disabled
//               className='form-control-lg text-center bg-white bg-opacity-5'
//               type='text'
//               autoComplete='off'
//               name='usersName'
//               onChange={formik.handleChange}
//               value={formik.values.usersName}
//               isInvalid={formik.touched.usersName && formik.errors.usersName}
//             />
//             <Form.Control.Feedback type='invalid'>{formik.errors.usersName}</Form.Control.Feedback>
//           </div>

//           <div className='mb-3'>
//             <label className='form-label fw-semibold'>
//               <i className='bi bi-lock-fill text-theme me-2' aria-hidden='true' />
//               {t('CurrentPassword')}
//               <span className='text-danger'>*</span>
//             </label>

//             <InputGroup>
//               <Form.Control
//                 className='form-control-lg text-center bg-white bg-opacity-5'
//                 type={showPassword ? 'text' : 'password'}
//                 name='currentPassword'
//                 placeholder={t('EnterCurrentPassword')}
//                 onChange={formik.handleChange}
//                 value={formik.values.currentPassword}
//                 isInvalid={formik.touched.currentPassword && formik.errors.currentPassword}
//                 autoComplete='off'
//               />
//               <Button type='button' variant='outline-theme' onClick={togglePasswordVisibility}>
//                 <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`} aria-hidden='true' />
//               </Button>
//             </InputGroup>
//             <Form.Control.Feedback type='invalid'>{formik.errors.currentPassword}</Form.Control.Feedback>
//           </div>

//           <div style={{ display: 'none' }}>
//             <input type='password' name='hidden-password' />
//           </div>

//           <div className='mb-3'>
//             <label className='form-label fw-semibold'>
//               <i className='bi bi-key-fill text-theme me-2' aria-hidden='true' />
//               {t('NewPassword')}
//               <span className='text-danger'>*</span>
//             </label>

//             <InputGroup>
//               <Form.Control
//                 className='form-control-lg text-center bg-white bg-opacity-5'
//                 type={shownewPassword ? 'text' : 'password'}
//                 name='newPassword'
//                 placeholder={t('EnterNewPassword')}
//                 onChange={formik.handleChange}
//                 value={formik.values.newPassword}
//                 isInvalid={formik.touched.newPassword && formik.errors.newPassword}
//               />
//               <Button type='button' variant='outline-theme' onClick={toggleNewPasswordVisibility}>
//                 <i className={`bi ${shownewPassword ? 'bi-eye-slash' : 'bi-eye'}`} aria-hidden='true' />
//               </Button>
//             </InputGroup>

//             <div className='mt-2 bg-inverse bg-opacity-5 rounded-1 p-1'>
//               <PasswordChecklist
//                 rules={['minLength', 'specialChar', 'number', 'capital']}
//                 minLength={8}
//                 value={formik.values.newPassword}
//                 messages={{
//                   minLength: t('ContainsMoreThan_8_Characters'),
//                   specialChar: `${t('ContainsSpecialCharacters')} [! @ # $ % ^ & *] `,
//                   number: t('ContainAtLeastOneNumber'),
//                   capital: t('ContainAtLeastOneCapitalLetter')
//                 }}
//               />
//             </div>
//           </div>

//           <div className='mb-3'>
//             <label className='form-label fw-semibold'>
//               <i className='bi bi-check-circle-fill text-theme me-2' aria-hidden='true' />
//               {t('ConfirmNewPassword')}
//               <span className='text-danger'>*</span>
//             </label>

//             <InputGroup>
//               <Form.Control
//                 className='form-control-lg text-center bg-white bg-opacity-5'
//                 type={showconfirmnewPassword ? 'text' : 'password'}
//                 name='comfirmdNewPassword'
//                 placeholder={t('ConfirmNewPassword')}
//                 onChange={formik.handleChange}
//                 value={formik.values.comfirmdNewPassword}
//                 isInvalid={formik.touched.comfirmdNewPassword && formik.errors.comfirmdNewPassword}
//               />
//               <Button type='button' variant='outline-theme' onClick={toggleConfirmNewPasswordVisibility}>
//                 <i className={`bi ${showconfirmnewPassword ? 'bi-eye-slash' : 'bi-eye'}`} aria-hidden='true' />
//               </Button>
//             </InputGroup>

//             <div className='mt-2 bg-inverse bg-opacity-5 rounded-1 p-1'>
//               <PasswordChecklist
//                 rules={['match']}
//                 value={formik.values.comfirmdNewPassword}
//                 valueAgain={formik.values.newPassword}
//                 messages={{
//                   match: t('MatchThePassword')
//                 }}
//               />
//             </div>
//           </div>

//           <div className='mb-3'></div>
//           <div className=' d-flex'>
//             <button
//               type='submit'
//               className='btn btn-theme btn-lg d-block w-100 fw-500 m-1'
//               disabled={formik.isSubmitting}
//             >
//               {formik.isSubmitting ? <div className='spinner-border text-theme spinner-border-sm '></div> : t('Save')}
//             </button>

//             <button
//               type='button'
//               className='btn btn-secondary btn-lg d-block w-100 fw-500 m-1'
//               disabled={formik.isSubmitting}
//               // onClick={() => navigate(-1, { replace: true })}
//               onClick={onClose}
//             >
//               {formik.isSubmitting ? (
//                 <div className='spinner-border text-secondary spinner-border-sm '></div>
//               ) : (
//                 t('Cancel')
//               )}
//             </button>
//           </div>
//         </Form>
//       </div>
//     </>
//   );
// }

// export default ChangePassword;


import { useFormik } from 'formik';
import React, { useState } from 'react';
import { Form, InputGroup, Button } from 'react-bootstrap';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { jwtDecode } from 'jwt-decode';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import { ChangePass } from '@store/Login/loginSlice';

// مكون مخصص للتحقق من قوة كلمة المرور
const PasswordStrengthChecklist = ({ password, confirmPassword, messages }) => {
  const checks = [
    {
      id: 'length',
      isValid: password.length >= 8,
      label: messages?.minLength || 'Contains more than 8 characters'
    },
    {
      id: 'uppercase',
      isValid: /[A-Z]/.test(password),
      label: messages?.capital || 'Contains at least one uppercase letter'
    },
    {
      id: 'number',
      isValid: /\d/.test(password),
      label: messages?.number || 'Contains at least one number'
    },
    {
      id: 'special',
      isValid: /[!@#$%^&*]/.test(password),
      label: messages?.specialChar || 'Contains special characters [!@#$%^&*]'
    },
    {
      id: 'match',
      isValid: password === confirmPassword && password !== '',
      label: messages?.match || 'Passwords match'
    }
  ];

  return (
    <div className="mt-2 bg-inverse bg-opacity-5 rounded-1 p-3">
      <div className="password-checklist">
        {checks.map((check) => (
          <div key={check.id} className="d-flex align-items-center mb-2">
            <div className={`me-2 ${check.isValid ? 'text-success' : 'text-secondary'}`}>
              <i className={`bi ${check.isValid ? 'bi-check-circle-fill' : 'bi-circle'}`} />
            </div>
            <span className={check.isValid ? 'text-success' : 'text-secondary'}>
              {check.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

function ChangePassword({ onClose }) {
  const { t } = useTranslation();
  const Token = useSelector(s => s.userLogin?.AuthUser?.token);
  const user = jwtDecode(Token);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  //#region ShowPassword
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(prevShowPassword => !prevShowPassword);
  };

  const [shownewPassword, setNewshowPassword] = useState(false);
  const toggleNewPasswordVisibility = () => {
    setNewshowPassword(prevShowPassword => !prevShowPassword);
  };

  const [showconfirmnewPassword, setConfirmnewshowPassword] = useState(false);
  const toggleConfirmNewPasswordVisibility = () => {
    setConfirmnewshowPassword(prevShowPassword => !prevShowPassword);
  };
  //#endregion

  //#region formik
  const formik = useFormik({
    initialValues: {
      usersName: user?.UserName,
      currentPassword: '',
      newPassword: '',
      comfirmdNewPassword: ''
    },

    validationSchema: Yup.object({
      usersName: Yup.string().trim().required('Username is required'),
      currentPassword: Yup.string().trim().required('Password is required'),

      newPassword: Yup.string()
        .min(8, 'كلمة المرور يجب أن تحتوي على أكثر من 8 أحرف')
        .matches(/(?=.*[A-Z])/, 'يجب أن تحتوي كلمة المرور على حرف كبير واحد على الأقل')
        .matches(/(?=.*\d)/, 'يجب أن تحتوي كلمة المرور على رقم واحد على الأقل')
        .matches(/(?=.*[!@#$%^&*])/, 'يجب أن تحتوي كلمة المرور على أحرف خاصة')
        .required(),

      comfirmdNewPassword: Yup.string()
        .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
        .required('Please confirm your new password')
    }),

    onSubmit: (values, { setErrors }) => {
      dispatch(
        ChangePass({
          usersName: values.usersName,
          currentPassword: values.currentPassword,
          newPassword: values.newPassword,
          comfirmdNewPassword: values.comfirmdNewPassword
        })
      )
        .unwrap()
        .then(res => {
          if (res?.succeeded === true) {
            CustomAlert({ action: 'Add', msg: 'تم تغيير كلمة المرور بنجاح' });
            formik.resetForm();
            formik.setSubmitting(false);
            navigate(-1, { replace: true });
          } else {
            CustomAlert({ action: 'Error', msg: res?.message });
            formik.setSubmitting(false);
          }
        })
        .catch(error => {
          console.log(error);
          formik.setSubmitting(false);
        });
    }
  });
  //#endregion

  // رسائل مترجمة للتحقق من كلمة المرور
  const passwordMessages = {
    minLength: t('ContainsMoreThan_8_Characters'),
    capital: t('ContainAtLeastOneCapitalLetter'),
    number: t('ContainAtLeastOneNumber'),
    specialChar: `${t('ContainsSpecialCharacters')} [!@#$%^&*]`,
    match: t('MatchThePassword')
  };

  return (
    <>
      <div className=' p-2'>
        <Form onSubmit={formik.handleSubmit}>
          <div className=' bg-inverse bg-opacity-10 rounded-1 p-2 mb-3 border border-theme '>
            <h5 className='text-center p-0 m-0'>{t('ChangePassword')}</h5>
          </div>

          <div className='mb-3'>
            <label className='form-label fw-semibold'>
              <i className='bi bi-person-fill text-theme me-2' aria-hidden='true' />
              {t('UserName')} <span className='text-danger'>*</span>
            </label>

            <Form.Control
              disabled
              className='form-control-lg text-center bg-white bg-opacity-5'
              type='text'
              autoComplete='off'
              name='usersName'
              onChange={formik.handleChange}
              value={formik.values.usersName}
              isInvalid={formik.touched.usersName && formik.errors.usersName}
            />
            <Form.Control.Feedback type='invalid'>{formik.errors.usersName}</Form.Control.Feedback>
          </div>

          <div className='mb-3'>
            <label className='form-label fw-semibold'>
              <i className='bi bi-lock-fill text-theme me-2' aria-hidden='true' />
              {t('CurrentPassword')}
              <span className='text-danger'>*</span>
            </label>

            <InputGroup>
              <Form.Control
                className='form-control-lg text-center bg-white bg-opacity-5'
                type={showPassword ? 'text' : 'password'}
                name='currentPassword'
                placeholder={t('EnterCurrentPassword')}
                onChange={formik.handleChange}
                value={formik.values.currentPassword}
                isInvalid={formik.touched.currentPassword && formik.errors.currentPassword}
                autoComplete='off'
              />
              <Button type='button' variant='outline-theme' onClick={togglePasswordVisibility}>
                <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`} aria-hidden='true' />
              </Button>
            </InputGroup>
            <Form.Control.Feedback type='invalid'>{formik.errors.currentPassword}</Form.Control.Feedback>
          </div>

          <div style={{ display: 'none' }}>
            <input type='password' name='hidden-password' />
          </div>

          <div className='mb-3'>
            <label className='form-label fw-semibold'>
              <i className='bi bi-key-fill text-theme me-2' aria-hidden='true' />
              {t('NewPassword')}
              <span className='text-danger'>*</span>
            </label>

            <InputGroup>
              <Form.Control
                className='form-control-lg text-center bg-white bg-opacity-5'
                type={shownewPassword ? 'text' : 'password'}
                name='newPassword'
                placeholder={t('EnterNewPassword')}
                onChange={formik.handleChange}
                value={formik.values.newPassword}
                isInvalid={formik.touched.newPassword && formik.errors.newPassword}
              />
              <Button type='button' variant='outline-theme' onClick={toggleNewPasswordVisibility}>
                <i className={`bi ${shownewPassword ? 'bi-eye-slash' : 'bi-eye'}`} aria-hidden='true' />
              </Button>
            </InputGroup>

            {/* التحقق من قوة كلمة المرور */}
            <PasswordStrengthChecklist
              password={formik.values.newPassword}
              confirmPassword={formik.values.comfirmdNewPassword}
              messages={passwordMessages}
            />
          </div>

          <div className='mb-3'>
            <label className='form-label fw-semibold'>
              <i className='bi bi-check-circle-fill text-theme me-2' aria-hidden='true' />
              {t('ConfirmNewPassword')}
              <span className='text-danger'>*</span>
            </label>

            <InputGroup>
              <Form.Control
                className='form-control-lg text-center bg-white bg-opacity-5'
                type={showconfirmnewPassword ? 'text' : 'password'}
                name='comfirmdNewPassword'
                placeholder={t('ConfirmNewPassword')}
                onChange={formik.handleChange}
                value={formik.values.comfirmdNewPassword}
                isInvalid={formik.touched.comfirmdNewPassword && formik.errors.comfirmdNewPassword}
              />
              <Button type='button' variant='outline-theme' onClick={toggleConfirmNewPasswordVisibility}>
                <i className={`bi ${showconfirmnewPassword ? 'bi-eye-slash' : 'bi-eye'}`} aria-hidden='true' />
              </Button>
            </InputGroup>
          </div>

          <div className='mb-3'></div>
          <div className=' d-flex'>
            <button
              type='submit'
              className='btn btn-theme btn-lg d-block w-100 fw-500 m-1'
              disabled={formik.isSubmitting}
            >
              {formik.isSubmitting ? <div className='spinner-border text-theme spinner-border-sm '></div> : t('Save')}
            </button>

            <button
              type='button'
              className='btn btn-secondary btn-lg d-block w-100 fw-500 m-1'
              disabled={formik.isSubmitting}
              onClick={onClose}
            >
              {formik.isSubmitting ? (
                <div className='spinner-border text-secondary spinner-border-sm '></div>
              ) : (
                t('Cancel')
              )}
            </button>
          </div>
        </Form>
      </div>
    </>
  );
}

export default ChangePassword;